// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"463e195e","194":"c75a8685","449":"759429d3","863":"2ec996e5"}[chunkId] + ".chunk.js";
};